<template>
  <div>
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar
            ref="previewEl"
            :src="previewProfile ? previewProfile : `https://api.banafshebagheri.simagar.com/${selfie}`"
            :text="avatarText(name)"
            :variant="`light-${resolveUserRoleVariant(userData.type)}`"
            rounded
            size="90px"
        />
      </template>
      <h4 class="mb-1">
        {{ name }}
      </h4>
      <div class="d-flex flex-wrap">
        <b-button
            variant="primary"
            @click="$refs.refInputEl.click()"
        >
          <input
              ref="refInputEl"
              class="d-none"
              type="file"
              @input="inputImageRenderer"
          >
          <span class="d-none d-sm-inline">ویرایش</span>
          <feather-icon
              class="d-inline d-sm-none"
              icon="EditIcon"
          />
        </b-button>
        <b-button
            class="ml-1"
            variant="outline-secondary"
            @click="removeProfile"
        >
          <span class="d-none d-sm-inline">حذف عکس پروفایل</span>
          <feather-icon
              class="d-inline d-sm-none"
              icon="TrashIcon"
          />
        </b-button>
      </div>
    </b-media>

    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>

        <!-- Field:  Name -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="نام"
              label-for="نام"
          >
            <b-form-input
                id="name"
                v-model="userData.name"
            />
          </b-form-group>
        </b-col>

        <!-- Field:  familyName -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="نام خانوادگی"
              label-for="familyName"
          >
            <b-form-input
                id="familyName"
                v-model="userData.familyName"
            />
          </b-form-group>
        </b-col>

        <!-- Field: mobile -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="موبایل"
              label-for="mobile"
          >
            <b-form-input
                dir="auto"
                id="mobile"
                v-model="userData.mobile"
            />
          </b-form-group>
        </b-col>

        <!-- Field: nationalId -->
<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--        >-->
<!--          <b-form-group-->
<!--              label="کد ملی"-->
<!--              label-for="nationalId"-->
<!--          >-->
<!--            <b-form-input-->
<!--                id="nationalId"-->
<!--                v-model="userData.nationalId"-->
<!--            />-->
<!--          </b-form-group>-->
<!--        </b-col>-->

        <!-- Field: Status -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="وضعیت کاربر"
              label-for="user-status"
          >
            <v-select
                v-model="userData.status"
                :clearable="false"
                :options="statusOptions"
                :reduce="val => val.value"
                input-id="user-status"
            />
          </b-form-group>
        </b-col>

        <!-- Field: instagram -->
<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--        >-->
<!--          <b-form-group-->
<!--              label="اینستاگرام"-->
<!--              label-for="mobile"-->
<!--          >-->
<!--            <b-form-input-->
<!--                dir="auto"-->
<!--                id="instagram"-->
<!--                v-model="userData.instagramId"-->
<!--            />-->
<!--          </b-form-group>-->
<!--        </b-col>-->

        <!-- Field: sexuality -->
<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--        >-->
<!--          <b-form-group-->
<!--              label="جنسیت"-->
<!--              label-for="sexuality"-->
<!--          >-->
<!--            <v-select-->
<!--                v-model="userData.sexuality"-->
<!--                :clearable="false"-->
<!--                :options="sexualityOptions"-->
<!--                :reduce="val => val.value"-->
<!--                input-id="user-status"-->
<!--            />-->
<!--          </b-form-group>-->
<!--        </b-col>-->

        <!-- Field: birthDate -->
<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--        >-->
<!--          <b-form-group-->
<!--              label="تاریخ تولد"-->
<!--              label-for="birthDate"-->
<!--          >-->
<!--            <input-->
<!--                id="birthDate"-->
<!--                :value="createJalaliDate(userData.birthDate)"-->
<!--                class="form-control form-control-lg w-11/12  mx-auto mt-1 mb-1 text-sm block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0 placeholder-inputPlaceHolder text-gray-700"-->
<!--                type="text"-->
<!--            />-->
<!--            <custom-date-picker-->
<!--                v-model="userData.birthDate"-->
<!--                class=""-->
<!--                color="#5c6bc0"-->
<!--                display-format="jYYYY/jMM/jDD HH:mm"-->
<!--                element="birthDate"-->
<!--                format="YYYY-MM-DD HH:mm"-->
<!--                input-format="YYYY-MM-DD HH:mm"-->
<!--                simple-->
<!--                type="date"-->
<!--            ></custom-date-picker>-->
<!--          </b-form-group>-->
<!--        </b-col>-->

        <!-- Field: state -->
        <!--        <b-col-->
        <!--            cols="12"-->
        <!--            md="4"-->
        <!--        >-->
        <!--          <b-form-group-->
        <!--              label="وضعیت"-->
        <!--              label-for="state"-->
        <!--          >-->
        <!--            <v-select-->
        <!--                v-model="userData.state"-->
        <!--                :clearable="false"-->
        <!--                :options="stateOptions"-->
        <!--                :reduce="val => val.value"-->
        <!--                class="mt-1"-->
        <!--                input-id="user-status"-->
        <!--            />-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->

<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--        >-->
<!--          <b-form-group-->
<!--              label="وضعیت کاربر"-->
<!--              label-for="state"-->
<!--          >-->
<!--            <v-select-->
<!--                v-model="userData.isBlocked"-->
<!--                :clearable="false"-->
<!--                :options="blockOptions"-->
<!--                :reduce="val => val.value"-->
<!--                class="mt-1"-->
<!--                input-id="user-status"-->
<!--            />-->
<!--          </b-form-group>-->
<!--        </b-col>-->

        <!-- Field: password -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="تغییر رمز عبور کاربر"
              label-for="password"
          >
            <b-form-input
                id="password"
                v-model="userData.password"
                class="mt-1"
            />
          </b-form-group>
        </b-col>

      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <b-button
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        variant="primary"
        @click="submitEdit"
    >
      ذخیره تغییرات
    </b-button>
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BRow,
  BTable,
} from 'bootstrap-vue'
import {avatarText} from '@core/utils/filter'
import vSelect from 'vue-select'
import {useInputImageRenderer} from '@core/comp-functions/forms/form-utils'
import {ref} from '@vue/composition-api'
import useUsersList from '../users-list/useUsersList'

export default {
  data() {
    return {
      tempProfile: null,
      sexualityOptions: [
        {label: 'مرد', value: 1},
        {label: 'زن', value: 2},
      ],
      blockOptions: [
        {label: 'بلاک شده', value: true},
        {label: 'بلاک نشده', value: false},
      ],
      stateOptions: [
        {label: 'وارد شده', value: 1},
        {label: 'فالو نکرده', value: 2},
        {label: 'آیدی اشتباه', value: 3},
      ],
    }
  },
  computed: {
    name() {
      return this.userData.name + ' ' + this.userData.familyName
    },
    today() {
      // let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      // let test = new Date().toLocaleDateString('fa-IR',options);
      // return  test.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728));
      return new Date()
    }
  },
  methods: {
    createJalaliDate(param) {
      if (param !== null) {
        return new Date(param).toLocaleDateString("fa-IR",);
      }
    },
    submitEdit() {
      this.$emit('submitEdit')
    },
    removeProfile() {
      this.userData.selfieFileData = 'Delete'
      this.previewProfile = null
      this.selfie = null
    }
  },
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    selfie: {
      type: String,
    }
  },
  setup(props) {
    const {resolveUserRoleVariant} = useUsersList()

    const statusOptions = [
      {label: 'فعال', value: 1},
      {label: 'غیرفعال', value: 2},
    ]

    const permissionsData = [
      {
        module: 'Admin',
        read: true,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: 'Staff',
        read: false,
        write: true,
        create: false,
        delete: false,
      },
      {
        module: 'Author',
        read: true,
        write: false,
        create: true,
        delete: false,
      },
      {
        module: 'Contributor',
        read: false,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: 'User',
        read: false,
        write: false,
        create: false,
        delete: true,
      },
    ]

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const previewProfile = ref(null)

    const {inputImageRenderer} = useInputImageRenderer(refInputEl, (base64, preview) => {
      // eslint-disable-next-line no-param-reassign
      props.userData.selfieFileData = base64
      console.log(base64)
      console.log(preview)
      previewProfile.value = preview
    }, previewEl)

    return {
      resolveUserRoleVariant,
      avatarText,
      statusOptions,
      permissionsData,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      previewProfile,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
